import { render, staticRenderFns } from "./StructDetails.vue?vue&type=template&id=420d531c"
import script from "./StructDetails.vue?vue&type=script&lang=js"
export * from "./StructDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports